import { ZionSmartBanner } from '@catalogo/ui-americanas-mobile-zion-smart-banner';
import withSmartBanner from '@catalogo/service-americanas-spacey/src/hocs/smart-banner';

export default withSmartBanner(ZionSmartBanner);
